import {ref} from "vue";
import {useLog} from "@/composables/useLog";
import {authFetch} from "@/composables/useAuthFetch";

const log = useLog("useSaveUrl");

async function refreshClerkUser(user) {
  try {
    await window.Clerk?.session?.touch();
    await user.reload();
  } catch (error) {
    log(`refresh failed: ${error?.message}`);
  }
}

async function postUrl(user, url) {
  const body = {
    firstName: user.firstName || "",
    lastName: user.lastName || "",
    publicMetadata: {url: url || ""},
    overwrite: true,
  };
  const response = await authFetch("/api/v1/user/update/clerk", {
    method: "POST",
    headers: {"Content-Type": "application/json"},
    body: JSON.stringify(body),
  });
  const data = await response.json();
  return data.ok === true;
}

export function useSaveUrl() {
  const isSaving = ref(false);

  async function save(user, url) {
    if (!user) return false;
    isSaving.value = true;
    try {
      const ok = await postUrl(user, url);
      log(`save result: ok=${ok}`);
      if (ok) await refreshClerkUser(user);
      return ok;
    } catch (error) {
      log(`save error: ${error?.message}`);
      return false;
    } finally {
      isSaving.value = false;
    }
  }

  return {isSaving, save};
}
